import { type Thread } from './Thread'

export const MAX_TITLE_LENGTH = 120

export function displayTitle(thread: Thread): string {
  return thread.title.trim() || 'New chat'
}

export function validateTitle(
  raw: string
): { ok: true; title: string } | { ok: false; reason: string } {
  const title = raw.trim()

  if (!title) return { ok: false, reason: 'Enter a name for this conversation.' }
  if (title.length > MAX_TITLE_LENGTH) {
    return { ok: false, reason: `Use ${MAX_TITLE_LENGTH} characters or fewer.` }
  }

  return { ok: true, title }
}
